// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "teren-map" + "." + "bfb00d46180e764ab235" + ".css";
};